import axios from '@/api/axios'


const getNotesList = (data) => {
    return axios
        .post('/admin/notes/notes-list', {notes: data})
        .then(response => response.data)
}

const notesAdd = (data) => {
    return axios
        .post('/admin/notes/notes-add', {notes: data})
        .then(response => response.data)
}

const notesEdit = (data) => {
    return axios
        .post('/admin/notes/notes-edit', {notes: data})
        .then(response => response.data)
}

const notesRemove = (data) => {
    return axios
        .post('/admin/notes/notes-remove', {notes: data})
        .then(response => response.data)
}

export default {
    getNotesList,
    notesAdd,
    notesEdit,
    notesRemove
}
